import {
  AnalyticsDataPointTypesEnum,
  AnalyticsDonutMetricValue,
  AnalyticsTableMetric,
  isNumericDataPoint,
  isStringDataPoint,
} from '../../models/api/analyticsMetricsModel';
import {TableToDonutMetricTransformer} from './analyticsMetricsTransformers';
import {
  AnalyticsComputedGraphMetricBase,
  AnalyticsComputedGraphMetricsEnum,
  AnalyticsComputedMetricTypesEnum,
} from './analyticsMetricsTransformersTypes';

/*
 * Transformer.
 */

export const histoMetricToDonut: TableToDonutMetricTransformer = (
  id: AnalyticsComputedGraphMetricsEnum,
  metricData: AnalyticsTableMetric | undefined,
): AnalyticsComputedGraphMetricBase<AnalyticsDonutMetricValue> => {
  const transformedMetricBase = {
    id,
    metricType: AnalyticsComputedMetricTypesEnum.CUSTOM_GRAPH,
    isEmpty: metricData?.isEmpty ?? false,
  };

  if (!metricData) {
    return {
      ...transformedMetricBase,
      values: [],
    };
  }

  return {
    ...transformedMetricBase,
    values: metricData.rows.map((row) => {
      const [labelRow, valueRow] = row;

      if (!isStringDataPoint(labelRow) || !isNumericDataPoint(valueRow)) {
        throw new Error('histogram metric to graph bad data format');
      }

      return {
        label: labelRow.value,
        type: AnalyticsDataPointTypesEnum.PERCENTAGE,
        value: valueRow.value,
        previousValue: valueRow.previousValue,
      };
    }),
  };
};
